import { useCallback, useState } from 'react';

import { LocaleContent, MarketContent, OpCoContent, OpCoListContent, useRequiredContent } from '../services/content';

interface PreferencesModalState {
  opco: string;
  market: string;
  locale: string;
}

export const usePreferencesModalState = (): [PreferencesModalState, (newState: Partial<PreferencesModalState>) => void] => {
  const { data: opcos } = useRequiredContent(OpCoListContent);
  const { data: currentOpco } = useRequiredContent(OpCoContent);
  const { data: currentMarket } = useRequiredContent(MarketContent);
  const { data: currentLocale } = useRequiredContent(LocaleContent);

  const [state, setState] = useState<PreferencesModalState>({ opco: currentOpco.id, market: currentMarket.id, locale: currentLocale.id });

  const updateState = useCallback(
    (newState: Partial<PreferencesModalState>) =>
      setState((prev) => {
        const combined = { ...prev, ...newState };

        const newOpCo = opcos.find((opco) => opco.id === combined.opco)!;

        return {
          opco: combined.opco,
          market: newOpCo.markets.find((market) => market.id === combined.market) ? combined.market : newOpCo.markets[0].id,
          locale: newOpCo.locales.find((locale) => locale.id === combined.locale) ? combined.locale : newOpCo.locales[0].id,
        };
      }),
    [opcos]
  );

  return [state, updateState];
};
